import styled from 'styled-components';

export const AlertWrapper = styled.div`
    .MuiAlert-root {
        margin: 0;
    }

    margin-bottom: 24px;
`;


type StyledProps = {
    isPublished: boolean;
};
export const BasicInputWrapper = styled.div<StyledProps>`
    margin-top: 16px;
    margin-bottom: 4px;
    .MuiInputBase-root, input {
        background: ${({ isPublished }): string => (isPublished ? '#fff' : 'auto')};
    }
`;